import { isHaveRole } from "./permissions";

export const adminMenu = () => {
  const menu = [
    { name: "Dashboard", path: "/dashboard", roles: ["admin"] },
    { name: "Document OCR", path: "/ocr", roles: ["admin", "agent"] },
    { name: "Utilisateur", path: "/users", roles: ["admin"] },
  ];

  return menu
    .map((section) => {
      if (section.children) {
        const children = section.children.filter(child => {
          return !child.roles || child.roles.some(role => isHaveRole(role));
        });
        return children.length ? { ...section, children } : null;
      }

      if (section.roles && !section.roles.some(role => isHaveRole(role))) {
        return null;
      }

      return section;
    })
    .filter(Boolean);
};
